import { createApp, type App } from 'vue'
import SearchInput from '~/ui/SearchInput.vue'
import { populate, populateAll } from './affiliate'
import IframeAPI from '~/api/IframeAPI'

type FinderOption = {
  turnstile: { key: string }
}

class B2BFinder {
  instance: App<Element>|undefined
  option: FinderOption
  api = new IframeAPI(import.meta.env.VITE_UI_URL)

  static affiliate = Object.freeze({ populate, populateAll })

  constructor(opt: FinderOption) {
    this.option = opt
    this.api.init()
  }

  mount(e: any) {
    this.instance?.unmount()

    this.instance = createApp(SearchInput)
      .provide('turnstile.key', this.option.turnstile.key)
      .provide(IframeAPI.$, this.api)

    this.instance.mount(e)
  }

  unmount() {
    this.instance?.unmount()
    this.instance = undefined
  }
}

Object.assign(window, { B2BFinder })

export default B2BFinder